// Cálculos del módulo Envíos Flex (paquetes retirados por la empresa de despacho).
import { parseFecha, claveMes } from './format';

const num = (n) => Number(n || 0);
const pad = (n) => String(n).padStart(2, '0');
const aISO = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const DIAS_CORTOS = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];

export function sumarDias(fechaISO, dias) {
  const d = parseFecha(fechaISO);
  d.setDate(d.getDate() + dias);
  return aISO(d);
}

// Lunes de la semana de la fecha (las semanas van de lunes a domingo).
export function inicioSemana(fechaISO) {
  const d = parseFecha(fechaISO);
  const diasDesdeLunes = (d.getDay() + 6) % 7;
  d.setDate(d.getDate() - diasDesdeLunes);
  return aISO(d);
}

export const totalRetiro = (r) => num(r.cantidad) * num(r.precio_unitario);

function resumir(retiros) {
  return {
    paquetes: retiros.reduce((s, r) => s + num(r.cantidad), 0),
    total: retiros.reduce((s, r) => s + totalRetiro(r), 0),
  };
}

// Paquetes y monto por zona.
export function porZona(retiros) {
  const r = {};
  retiros.forEach(x => {
    const z = (r[x.zona] = r[x.zona] || { zona: x.zona, paquetes: 0, total: 0 });
    z.paquetes += num(x.cantidad);
    z.total += totalRetiro(x);
  });
  return Object.values(r).sort((a, b) => b.paquetes - a.paquetes);
}

// Semanas (de la más reciente a la más antigua) con el detalle de cada día.
// Incluye las semanas que solo tienen registro de cobro, aunque no tengan retiros anotados.
export function agruparPorSemana(retiros, semanas = []) {
  const grupos = {};
  const asegurar = (inicio) => (grupos[inicio] = grupos[inicio] || []);
  retiros.forEach(r => asegurar(inicioSemana(r.fecha)).push(r));
  semanas.forEach(s => asegurar(s.semana_inicio));

  return Object.keys(grupos)
    .sort((a, b) => b.localeCompare(a))
    .map(inicio => {
      const rs = grupos[inicio];
      const dias = DIAS_CORTOS.map((nombre, i) => {
        const fecha = sumarDias(inicio, i);
        return { nombre, fecha, ...resumir(rs.filter(r => r.fecha === fecha)) };
      });
      return {
        inicio,
        fin: sumarDias(inicio, 6),
        dias,
        zonas: porZona(rs),
        registro: semanas.find(s => s.semana_inicio === inicio) || null,
        ...resumir(rs),
      };
    });
}

// Totales por mes (según la fecha de cada retiro) y lo pagado (según la semana pagada).
export function agruparPorMesEnvios(retiros, semanas = []) {
  const meses = {};
  const asegurar = (clave) => (meses[clave] = meses[clave] || { clave, retiros: [], pagado: 0 });
  retiros.forEach(r => asegurar(claveMes(r.fecha)).retiros.push(r));
  semanas.filter(s => s.pagado).forEach(s => {
    asegurar(claveMes(s.fecha_pago || s.semana_inicio)).pagado += num(s.monto_pagado);
  });
  return Object.values(meses)
    .sort((a, b) => b.clave.localeCompare(a.clave))
    .map(m => ({ ...m, ...resumir(m.retiros), zonas: porZona(m.retiros) }));
}
